import { CURRENCIES } from 'types/bussines';
import { IOrderPriceEdition, IOrderWithProductPrices } from 'types/orders';
import { IOrderPriceEditionForm } from 'views/orders/OrderPriceEdition/OrderPriceEdition.types';

export const EDITION_FORM_DEFAULT_VALUES: IOrderPriceEditionForm = {
  sales: [],
  exchangeRate: 0,
  currency: CURRENCIES.USD,
  subtotal: 0,
  totalUsd: 0,
  totalLocal: 0,
  iva: 0,
  reason: undefined,
  commissionUsd: 0,
  shippingValueUsd: 0
};

const removeTaxesFromValue = (value: number, taxPercentage: number) => {
  if (!value || !taxPercentage) {
    return value;
  }
  const divisor = 1 + taxPercentage / 100;
  if (divisor <= 0) {
    return value;
  }
  return Number((value / divisor).toFixed(2));
};

export const buildCurrentSales = (
  data: IOrderPriceEditionForm,
  orderData?: IOrderWithProductPrices,
  shouldApplyTaxes?: boolean
): IOrderPriceEdition['items'] => {
  const taxPercentage = shouldApplyTaxes ? Number(orderData?.orderPrice?.tax ?? 0) : 0;
  return data.sales
    .filter(sale => sale.id)
    .map(sale => {
      const saleValueUsd = Number(sale.saleValueUsd) || 0;
      return {
        saleId: sale.id as number,
        currency: String(data.currency) || CURRENCIES.USD,
        previousUnitAmount: Number(orderData?.sales?.find(currSale => currSale.id === sale.id)?.saleValueUsd || 0),
        newUnitAmount: removeTaxesFromValue(saleValueUsd, taxPercentage),
        totalLocalAmount: Number(sale.saleValue) || 0
      };
    });
};

export const buildPriceEditionPayload = (
  data: IOrderPriceEditionForm,
  orderData?: IOrderWithProductPrices,
  shouldApplyTaxes?: boolean
): IOrderPriceEdition | null => {
  if (!orderData) return null;
  const currentSales = buildCurrentSales(data, orderData, shouldApplyTaxes);
  return {
    orderId: orderData.id,
    currency: data.currency,
    previousTotalAmount: Number(orderData?.orderPrice?.totalValueUsd),
    newTotalAmount: data.totalUsd,
    totalLocalAmount: data.totalLocal,
    reason: data.reason,
    exchangeRate: Number(data.exchangeRate) || 1,
    commissionUsd: Number(data.commissionUsd || 0),
    changedAt: new Date().toISOString(),
    needInvoice: true,
    previousInvoiceUrl: orderData?.orderSummaryPDF,
    items: [...currentSales]
  };
};

export const initializePriceEditionForm = (orderData?: IOrderWithProductPrices): IOrderPriceEditionForm => ({
  sales: orderData?.sales || [],
  currency: orderData?.orderPrice?.currency || CURRENCIES.USD,
  exchangeRate: Number(orderData?.orderPrice?.exchangeRate) || 0,
  subtotal: Number(orderData?.orderPrice?.subtotalSaleValueUsd) || 0,
  totalUsd: Number(orderData?.orderPrice?.totalValueUsd) || 0,
  totalLocal: Number(orderData?.orderPrice?.totalValue) || 0,
  iva: Number(orderData?.orderPrice?.totalTaxesUsd || 0),
  commissionUsd: Number(orderData?.orderPrice?.commissionValueUsd || 0),
  shippingValueUsd: Number(orderData?.orderPrice?.shipmentValueUsd || 0),
  levelSubscription: orderData?.organizationData?.platformSubscription || undefined
});
